export const SKILLS = [
  {
    category: 'ML & Deep Learning',
    items: [
      'TensorFlow', 'PyTorch', 'Scikit-learn', 'RAG', 'Hugging Face', 'LangChain',
      'Generative AI', 'Model evaluation', 'Model monitoring',
    ],
  },
  {
    category: 'LLMs & NLP',
    items: [
      'Llama', 'GPT-4o', 'Claude', 'BERT', 'BERTopic', 'UMAP', 'DPR', 'BGE-M3',
      'Sentence-Transformers', 'FAISS', 'HNSW', 'SFT', 'LoRA', 'RLHF',
    ],
  },
  {
    category: 'MLOps, Cloud & Monitoring',
    items: [
      'AWS', 'SageMaker', 'Lambda', 'CloudFormation', 'Terraform', 'Docker',
      'Kubernetes', 'Google Cloud Run', 'CI/CD', 'MLflow', 'Weights & Biases',
    ],
  },
  {
    category: 'API & Backend',
    items: [
      'Python', 'FastAPI', 'REST APIs', 'GraphQL', 'PostgreSQL', 'SQL',
      'AWS API Gateway', 'Data pipelines',
    ],
  },
];
